import { combineReducers } from 'redux'
import { loadmaskReducer } from 'react-redux-loadmask'
import { routerReducer } from 'react-router-redux'


const initialPageState = {
}


function page(state=initialPageState, action){
   switch (action.type) {
      default:
         return state
   }
}

const reducers = combineReducers({
   page,
   loadmaskReducer,
   routing: routerReducer
})

export default reducers



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/